import React, { useState } from 'react';
import { Input, Upload, Button, Spin } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { UploadOutlined } from '@ant-design/icons';
import {belen_uri} from "../../../utils/url";
import { toast } from 'react-toastify';
import { CATEGORY } from '../../../utils/types';
import { Checkbox } from '@nextui-org/react';
 import { MdDelete } from "react-icons/md";

const BelenBaraaAdd = () => {
    const [fileList, setFileList] = useState([]);
    const handleUpload = ({ fileList }) => setFileList(fileList);
    const [data, setData] = useState({title:"", price:"", desc:"", category:"", limit:""});
    const [load, setLoad] = useState(false);
    const [checkbox, setCheckbox] = useState(false);
    const [sizes, setSizes] = useState([]);
    const [sizeInput, setSizeInput] = useState("");
    const [stockInput, setStockInput] = useState("");
    const [name, setName] = useState("");


    const handleAddSize = () => {
        if (sizeInput.trim() && stockInput.trim() && !sizes.some(s => s.size === sizeInput)) {
            setSizes([...sizes, { size: sizeInput, stock: stockInput }]);
            setSizeInput("");
            setStockInput(""); // Оруулсан утгыг цэвэрлэх
        }
    };

    // Размер устгах
    const handleRemoveSize = (sizeToRemove) => {
        setSizes(sizes.filter(size => size !== sizeToRemove));
    };

    const handleSubmit = async () => {
        if(data.category == "" || data.desc == "" || data.limit == "" || data.price == "" || data.title == ""){
            toast.error("Бөглөгдөөгүй талбар байна !");
        }
        setLoad(true);
        const formData = new FormData();
        fileList.forEach(file => {
            formData.append('images', file.originFileObj);
        });
    
        formData.append('title', data.title);
        formData.append('price', data.price);
        formData.append('desc', data.desc);
        formData.append('category', data.category);
        formData.append('limit', data.limit);
        formData.append('sizes', JSON.stringify(sizes));
        formData.append('name', name);
        if(checkbox == true){
            formData.append('sizeYesNo', "Y");
        }

        console.log(sizes.length)
        
        const response = await fetch(belen_uri+'/image', {
            method: 'POST',
            body: formData
        });
    
        if (response.ok) {
            setLoad(false);
            setData({...data, title:"", desc:"", price:"", limit:""});
            setSizes([]);
            setName("");
            setFileList([]);
            toast.success("Амжилттай бараа нэмэгдсэн");
        } else {
            console.error('Upload failed');
            setLoad(false);
        }
    };

  
    return (
        <div>
            <div className='bg-white rounded-md p-4 h-full pb-40'>
                <div>
                    <h1 className='text-lg'>Бэлэн бараа нэмэх</h1>
                    <div className='mt-3 mx-4'>
                        <h1 className='mt-4'>Барааны нэр</h1>
                        <Input value={data.title} onChange={(e)=> setData({...data, title:e.target.value})} className='mt-2' size='large' placeholder='Барааны нэр оруулах' />
                        <h1 className='mt-4'>Дэлгэрэнгүй мэдээлэл</h1>
                        <TextArea value={data.desc} onChange={(e)=> setData({...data, desc:e.target.value})} className='mt-2' size='large' placeholder='Дэлгэрэнгүй мэдээлэл оруулах' />
                        <h1 className='mt-4'>Үнэ</h1>
                        <Input className='mt-2' value={data.price} onChange={(e)=> setData({...data, price:e.target.value})} size='large' placeholder='Үнэ оруулах' type='number' />
                        <h1 className='mt-4'>Нийт үлдэгдэл оруулах</h1>
                        <Input className='mt-2' value={data.limit} onChange={(e)=> setData({...data, limit:e.target.value})} size='large' placeholder='Үнэ оруулах' type='number' />
                        <h1 className='mt-4'>Барааны төрөл сонгох</h1>
                        <select className='mt-2 p-2 runded-md outline-none border border-gray-100' onChange={(e)=> setData({...data, category:e.target.value})}>
                            <option>Сонгох</option>
                            <option value={CATEGORY.GER}>Гэр ахуй</option>
                            <option value={CATEGORY.CLOTHS}>Хувцас</option>
                            <option value={CATEGORY.OTHER}>Бусад</option>
                            <option value={CATEGORY.ONTSLOH}>Онцлох</option>
                        </select>
                        <div className='mt-6'>
                             <Checkbox checked={checkbox} onChange={(e) => setCheckbox(e.target.checked)}>
                                 Size -тай эсэх
                             </Checkbox>
                             {
                                 checkbox &&
                                 <div className='mt-4 bg-gray-200 p-2 rounded-md'>
                                     <Input className='my-2' value={name} onChange={(e) => setName(e.target.value)} placeholder='Размер, Хэмжээ гэх мэт нэрүүд байж болно'/>
                                     <div className='flex items-center gap-1'>
                                         <Input value={sizeInput} onChange={(e) => setSizeInput(e.target.value)} placeholder='Хэмжээ оруулах' />
                                         <Input value={stockInput} onChange={(e) => setStockInput(e.target.value)} placeholder='Үлдэгдэл оруулах' type='number' />
                                         <Button className='bg-blue-500 text-white' onClick={handleAddSize}>Нэмэх</Button>
                                     </div>
                                     <div className='m-2 flex gap-2'>
                                         {
                                             sizes.map((size, index) => (
                                                 <div key={index} className='flex bg-white rounded-md p-2 items-center gap-2'>
                                                     <h1>{size.size} ({size.stock} ширхэг)</h1>
                                                     <MdDelete onClick={() => handleRemoveSize(size)} size={22} color='red' className='cursor-pointer' />
                                                 </div>
                                             ))
                                         }
                                     </div>
                                 </div>
                             }
                         </div>
                        <h1 className='mt-4'>Зураг</h1>
                        <Upload
                            className='mt-2'
                            multiple
                            fileList={fileList}
                            onChange={handleUpload}
                            beforeUpload={() => false}
                            maxCount={8}
                        >
                            <Button className='mt-2' icon={<UploadOutlined />}>Зураг сонгох</Button>
                        </Upload>
                        <div className='mt-4 flex justify-end'>
                          {
                            load?
                            <Button className='bg-green-200 text-white' size='large'>
                              <Spin/>
                            </Button>
                            :
                            <Button onClick={handleSubmit} className='bg-green-600 text-white' size='large'>Хадгалах</Button>
                          }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BelenBaraaAdd;
